"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WORKER_OFFSCREEN_CANVAS = exports.WEBKIT = exports.SAFARI_BUG_237906 = exports.SAFARI = exports.PASSIVE_EVENT_LISTENERS = exports.MAC = exports.IMAGE_DECODE = exports.FIREFOX = exports.DEVICE_PIXEL_RATIO = void 0;

/**
 * @module ol/has
 */
var ua = typeof navigator !== 'undefined' && typeof navigator.userAgent !== 'undefined' ? navigator.userAgent.toLowerCase() : '';
/**
 * User agent string says we are dealing with Firefox as browser.
 * @type {boolean}
 */

var FIREFOX = ua.indexOf('firefox') !== -1;
/**
 * User agent string says we are dealing with Safari as browser.
 * @type {boolean}
 */

exports.FIREFOX = FIREFOX;
var SAFARI = ua.indexOf('safari') !== -1 && ua.indexOf('chrom') == -1;
/**
 * https://bugs.webkit.org/show_bug.cgi?id=237906
 * @type {boolean}
 */

exports.SAFARI = SAFARI;
var SAFARI_BUG_237906 = SAFARI && !!(ua.indexOf('version/15.4') >= 0 || ua.match(/cpu (os|iphone os) 15_4 like mac os x/));
/**
 * User agent string says we are dealing with a WebKit engine.
 * @type {boolean}
 */

exports.SAFARI_BUG_237906 = SAFARI_BUG_237906;
var WEBKIT = ua.indexOf('webkit') !== -1 && ua.indexOf('edge') == -1;
/**
 * User agent string says we are dealing with a Mac as platform.
 * @type {boolean}
 */

exports.WEBKIT = WEBKIT;
var MAC = ua.indexOf('macintosh') !== -1;
/**
 * The ratio between physical pixels and device-independent pixels
 * (dips) on the device (`window.devicePixelRatio`).
 * @const
 * @type {number}
 * @api
 */

exports.MAC = MAC;
var DEVICE_PIXEL_RATIO = typeof devicePixelRatio !== 'undefined' ? devicePixelRatio : 1;
/**
 * The execution context is a worker with OffscreenCanvas available.
 * @const
 * @type {boolean}
 */

exports.DEVICE_PIXEL_RATIO = DEVICE_PIXEL_RATIO;
var WORKER_OFFSCREEN_CANVAS = typeof WorkerGlobalScope !== 'undefined' && typeof OffscreenCanvas !== 'undefined' && self instanceof WorkerGlobalScope; //eslint-disable-line

/**
 * Image.prototype.decode() is supported.
 * @type {boolean}
 */

exports.WORKER_OFFSCREEN_CANVAS = WORKER_OFFSCREEN_CANVAS;
var IMAGE_DECODE = typeof Image !== 'undefined' && Image.prototype.decode;
/**
 * @type {boolean}
 */

exports.IMAGE_DECODE = IMAGE_DECODE;

var PASSIVE_EVENT_LISTENERS = function () {
  var passive = false;

  try {
    var options = Object.defineProperty({}, 'passive', {
      get: function get() {
        passive = true;
      }
    });
    window.addEventListener('_', null, options);
    window.removeEventListener('_', null, options);
  } catch (error) {// passive not supported
  }

  return passive;
}();

exports.PASSIVE_EVENT_LISTENERS = PASSIVE_EVENT_LISTENERS;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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